function convertPrice(price) {
  return (price * Shopify.currency.rate)
}

const localeMap = {
  AD: "ca-AD",
  AE: "ar-AE",
  AF: "fa-AF",
  AG: "en-AG",
  AI: "en-AI",
  AL: "sq-AL",
  AM: "hy-AM",
  AO: "pt-AO",
  AR: "es-AR",
  AS: "en-AS",
  AT: "de-AT",
  AU: "en-AU",
  AW: "nl-AW",
  AZ: "az-Latn-AZ",
  BA: "bs-BA",
  BB: "en-BB",
  BD: "bn-BD",
  BE: "nl-BE",
  BF: "fr-BF",
  BG: "bg-BG",
  BH: "ar-BH",
  BI: "fr-BI",
  BJ: "fr-BJ",
  BM: "en-BM",
  BN: "ms-BN",
  BO: "es-BO",
  BR: "pt-BR",
  BS: "en-BS",
  BT: "dz-BT",
  BW: "en-BW",
  BY: "be-BY",
  BZ: "en-BZ",
  CA: "en-CA",
  CD: "fr-CD",
  CF: "fr-CF",
  CG: "fr-CG",
  CH: "de-CH",
  CI: "fr-CI",
  CL: "es-CL",
  CM: "fr-CM",
  CN: "zh-CN",
  CO: "es-CO",
  CR: "es-CR",
  CU: "es-CU",
  CV: "pt-CV",
  CY: "el-CY",
  CZ: "cs-CZ",
  DE: "de-DE",
  DJ: "fr-DJ",
  DK: "da-DK",
  DM: "en-DM",
  DO: "es-DO",
  DZ: "ar-DZ",
  EC: "es-EC",
  EE: "et-EE",
  EG: "ar-EG",
  ER: "ti-ER",
  ES: "es-ES",
  ET: "am-ET",
  FI: "fi-FI",
  FJ: "en-FJ",
  FM: "en-FM",
  FR: "fr-FR",
  GA: "fr-GA",
  GB: "en-GB",
  GD: "en-GD",
  GE: "ka-GE",
  GH: "en-GH",
  GM: "en-GM",
  GN: "fr-GN",
  GQ: "es-GQ",
  GR: "el-GR",
  GT: "es-GT",
  GU: "en-GU",
  GW: "pt-GW",
  GY: "en-GY",
  HK: "zh-HK",
  HN: "es-HN",
  HR: "hr-HR",
  HT: "fr-HT",
  HU: "hu-HU",
  ID: "id-ID",
  IE: "en-IE",
  IL: "he-IL",
  IN: "hi-IN",
  IQ: "ar-IQ",
  IR: "fa-IR",
  IS: "is-IS",
  IT: "it-IT",
  JM: "en-JM",
  JO: "ar-JO",
  JP: "ja-JP",
  KE: "en-KE",
  KG: "ky-KG",
  KH: "km-KH",
  KI: "en-KI",
  KM: "ar-KM",
  KN: "en-KN",
  KP: "ko-KP",
  KR: "ko-KR",
  KW: "ar-KW",
  KY: "en-KY",
  KZ: "kk-KZ",
  LA: "lo-LA",
  LB: "ar-LB",
  LC: "en-LC",
  LI: "de-LI",
  LK: "si-LK",
  LR: "en-LR",
  LS: "st-LS",
  LT: "lt-LT",
  LU: "fr-LU",
  LV: "lv-LV",
  LY: "ar-LY",
  MA: "ar-MA",
  MC: "fr-MC",
  MD: "ro-MD",
  ME: "sr-ME",
  MG: "fr-MG",
  MH: "en-MH",
  MK: "mk-MK",
  ML: "fr-ML",
  MM: "my-MM",
  MN: "mn-MN",
  MR: "ar-MR",
  MT: "mt-MT",
  MU: "en-MU",
  MV: "dv-MV",
  MW: "en-MW",
  MX: "es-MX",
  MY: "ms-MY",
  MZ: "pt-MZ",
  NA: "en-NA",
  NE: "fr-NE",
  NG: "en-NG",
  NI: "es-NI",
  NL: "nl-NL",
  NO: "no-NO",
  NP: "ne-NP",
  NZ: "en-NZ",
  OM: "ar-OM",
  PA: "es-PA",
  PE: "es-PE",
  PG: "en-PG",
  PH: "en-PH",
  PK: "ur-PK",
  PL: "pl-PL",
  PT: "pt-PT",
  PW: "en-PW",
  PY: "es-PY",
  QA: "ar-QA",
  RO: "ro-RO",
  RS: "sr-RS",
  RU: "ru-RU",
  RW: "rw-RW",
  SA: "ar-SA",
  SB: "en-SB",
  SC: "fr-SC",
  SD: "ar-SD",
  SE: "sv-SE",
  SG: "en-SG",
  SI: "sl-SI",
  SK: "sk-SK",
  SL: "en-SL",
  SM: "it-SM",
  SN: "fr-SN",
  SO: "so-SO",
  SR: "nl-SR",
  SS: "ar-SS",
  ST: "pt-ST",
  SV: "es-SV",
  SY: "ar-SY",
  SZ: "en-SZ",
  TD: "fr-TD",
  TG: "fr-TG",
  TH: "th-TH",
  TJ: "tg-TJ",
  TL: "pt-TL",
  TM: "tk-TM",
  TN: "ar-TN",
  TO: "en-TO",
  TR: "tr-TR",
  TT: "en-TT",
  TV: "en-TV",
  TZ: "sw-TZ",
  UA: "uk-UA",
  UG: "en-UG",
  US: "en-US",
  UY: "es-UY",
  UZ: "uz-UZ",
  VE: "es-VE",
  VN: "vi-VN",
  VU: "fr-VU",
  WS: "en-WS",
  YE: "ar-YE",
  ZA: "en-ZA",
  ZM: "en-ZM",
  ZW: "en-ZW"
}

const separator = 1.1.toLocaleString(localeMap[Shopify.country] ?? "en-US").charAt(1)

function formatPrice(price, roundDirection) {
  return Math[roundDirection === "down" ? "floor" : "ceil"](convertPrice(price / 100)).toLocaleString(localeMap[Shopify.country] ?? "en-US", { style: "currency", currency: Shopify.currency.active }).replace(`${separator}00`, "")
}

function formatPriceWithCurrency(price, roundDirection) {
  const formatted = formatPrice(price, roundDirection)
  if (formatted.startsWith(Shopify.currency.active)) return formatted
  return `${formatted} ${Shopify.currency.active}`
} 
function formatConvertedPrice(price, roundDirection) {
  return Math[roundDirection === "down" ? "floor" : "ceil"](price / 100).toLocaleString(localeMap[Shopify.country] ?? "en-US", { style: "currency", currency: Shopify.currency.active }).replace(`${separator}00`, "")
}

/*
function formatPrice(price, roundDirection) {
  return Math[roundDirection === "down" ? "floor" : "ceil"](price / 100).toLocaleString("en-US", { style: "currency", currency: "USD" }).replace(`.00`, "")
}

function formatPriceWithCurrency(price, roundDirection) {
  const formatted = formatPrice(price, roundDirection)
  return `${formatted} USD`
}
*/